
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,  
            tagName:"select",
            droppable:false,
            draggable:false,
            removable:false,
            copyable:false,
            toolbar:[],
            attributes:{
                name:"",
                "data-slg-type":"C-SELECT-OPTIONS",
                "data-slg-coregistros":[],
                placeholder:""
            },
            classes:['form-control'],
            options:[],
            question_id:null,
            traits: [
                'placeholder',
                'name',
                {
                    type: 'checkbox',
                    name: 'required',
                }
            ]
        },
        renderAllOptions(options) {
            let component = this;
            
            options.forEach( (op) => {
                component.renderOption(op);
            });
        },
        renderOption:function(option){
            let component = this;
            let find = component.components().models.find(comp => {
                return option.key == comp.getId();
            });
            if(find){
                component.updateOption(option,find);
            }else{
                component.addOption(option)
            }
        },
        renderAttributeName(){
            let component = this;
            let attributes = component.get('attributes');
            // let question_id = (component.get("question_id")) ? component.get("question_id"):"" ;
            let parent_component = component.parent();
            let parent_attributes = parent_component.getAttributes();
            let question_id = parent_attributes['data-slg-question-id'];
            component.setAttributes({
                ...attributes,
                name:`answers[${question_id}]`
            });
        },
        addOption: function (option){
            let component = this;
            let coregistros = (option.coregistros)? JSON.stringify(option.coregistros):[];
            let option_component = {
                tagName:'option',
                attributes:{
                    id:option.key,
                    value:option.value,
                    "data-slg-coregistros":coregistros
                },
                content:option.label
            }
            component.append(option_component);
        },
        updateOption: function(option,component){
            let coregistros = (option.coregistros)? JSON.stringify(option.coregistros):[];
            let attributes = component.getAttributes();
            component.setAttributes({
                ...attributes,
                value:option.value,
                "data-slg-coregistros":coregistros
            });
            component.components(option.label);
        },
        deleteOption: function (option){
            let find = this.model.components().models.find(comp => {
                return option.key == comp.getId();
            })
            find.remove();
        },
        cleanOptions: function(options){
            let component = this;
            let components = component.components().models;
            let listToDelete = [];
            for (let i = 0; i < components.length; i++) {
                const comp = components[i];
                // console.log("Componente del option!");
                let find = options.find(op => op.key == comp.getId());
                
                if(!find){
                    // console.log("Componente no encontrado!");
                    listToDelete.push(comp.getId());
                }else{
                    // console.log("Componente encontrado!");
                }
            }
            listToDelete.forEach(item => { 
                let toDelete = components.find((comp)=>{
                    return comp.getId() == item
                });
                toDelete.remove();
            });
        },
        updatePlaceholder(){
            let component = this.model;
            console.log(component);
            let attributes = component.getAttributes();
            console.log({placeholder:attributes.placeholder});
            if(attributes.placeholder != ""){
                let option_component = {
                    tagName:'option',
                    attributes:{
                        value:"",
                        hidden:true
                    },
                    content:attributes.placeholder
                }
                component.append(option_component, { at: 0 });
            }
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-SELECT-OPTIONS")
                return { type:'C-SELECT-OPTIONS' }
        }
    });

    var view = VIEW.extend({

        init: function () {
          let component = this.model;
          this.listenTo(component, 'change:attributes change:shape', component.updateComponent);
          this.listenTo(component, 'change:attributes:placeholder', component.updatePlaceholder);

        },
        onRender() {
            let component = this.model
            component.renderAttributeName();
        },
        
    });

    DOMC.addType('C-SELECT-OPTIONS', {
      model:model,
      view:view,
    });
};
  